import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useController } from "../assets/components/BaseContrroler";
import { Typography } from "@mui/material";

function Earning() {
  const {
    baseController: { homeController },
  } = useController();
  const { setNavbar, setUrl } = homeController;

  useEffect(() => {
    setUrl("/earning");
    setNavbar(true);
  }, []);

  return (
    <div className="px-2" id="about">
      <div className="row align-items-center m-auto">
        {/* Left Image */}
        <div className="col-12 col-md-6 text-center text-md-start mb-4 mb-md-0">
          <img
            src={require("../assets/images/earning.png")}
            alt="karnafully"
            className="img-fluid rounded"
            style={{ maxHeight: "400px", objectFit: "cover" }}
          />
        </div>

        {/* Right Text */}
        <div className="col-12 col-md-6">
          <div className="d-flex align-items-center mb-3">
            <img
              src={require("../assets/images/logo-earning.png")}
              alt="karnafully"
              className="bg-dark p-2 me-2"
              style={{
                width: "60px",
                height: "60px",
                objectFit: "contain",
                borderRadius: "8px",
              }}
            />
            <h4 className="mb-0 fw-bold text-start">
              <span className="text-danger">COMPANY'S</span> <br /> EARNING
            </h4>
          </div>
          <Typography style={{ textAlign: "justify" }} className="pe-2">
            Aligned with the Government-approved Customs Act 2023, we earn
            service commissions from both importers and exporters as part of our
            commitment to seamless trade facilitation. These commissions are
            determined either as stipulated or through transparent negotiations,
            ensuring smooth communication and mutual agreement. Trust,
            integrity, and collaboration remain the cornerstones of our service
            excellence.
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default observer(Earning);
